import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maxLen',
    standalone: false
})
export class MaxLenPipe implements PipeTransform {

  transform(value: string, len: number): string {
    return value.substring(0, len);
  }

}
